import React, { useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { loadUser, logout } from '../../../Actions/Auth';
import '../MainHeader.css';
import styles from './Header.module.css';
import StripePayment from '../../../StripePayment/StripePayment';
import PaymentHistory from '../../../StripePayment/PaymentHistory';
import { BiSolidWallet, BiSolidUser, BiMenuAltRight, BiCrosshair } from 'react-icons/bi';
import { Modal, Form, Input, Button, ConfigProvider, Popconfirm } from 'antd';
import BreatheEV_Logo from '../../../Images/logo.png';
import BreatheEV_Mobile_Logo from '../../../Images/logo-mobile.png';
import Image from 'react-bootstrap/Image';
import { Navigate } from 'react-router-dom';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import {setFutureEstimateAmount} from '../../../Actions/Auth'
import ApplePay from '../../../StripePayment/ApplePay';
import GooglePay from '../../../StripePayment/GooglePay';
import CustomPWAButton from './components/CustomPWAButton';
import store from '../../../store';


const Header = (props) => {

  const [historyModal, setHistoryModal] = useState(false);
  const [walletModal, setWalletModal] = useState(false);
  const [walletRechargeModal, setWalletRechargeModal] = useState(false);
  const [bookings, setBookings] = useState([])
  const [selectedPart, setSelectedPart] = useState('part1');


  const [userMenu, setUserMenu] = useState(false);
  const userMenuRef = useRef(null);

  const [paymentHistoryPageNumber, setPaymentHistoryPageNumber] = useState(1)

  const [mobileMenu, setMobileMenu] = useState(false);
  const mobileMenuRef = useRef(null);

  const [userNRBookings, setUserNRBookings] = useState([]);
  const [isloading, setIsLoading] = useState(false)

  const dispatch = useDispatch()
//   const getBookings = async () => {
    
//     const res = await BreathAPIs.getBookings();
//     setBookings(res.data);
//     // console.log(res.data)
//     console.log(bookings)
    
// };

  // const setHistoryPagement
  // console.log("walletRechargeModal in header",walletRechargeModal)
  const handlePartChange = (part) => {
    setSelectedPart(part);
  };
  
  const setFutureEstimate = async ()=> {
    try {
      const res = await BreathAPIs.getUpcomingBookings();
      let now = new Date()
      let futureBookings = res.data.filter((bk)=>{
         return ((bk.bookingStatus === "Idle") || (new Date(bk.startTime) > now) || (new Date(bk.startTime) <= now && new Date(bk.endTime) >= now))
      })
     
      let totalFutureCost = 0;
      futureBookings.map((booking) => {
          totalFutureCost  += booking.estimateAmount
      }, 0);
      dispatch(setFutureEstimateAmount(totalFutureCost))
    } catch (error) {
      console.log("")
    }
      
       
  }


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenu(false);
      }

      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setMobileMenu(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [userMenu, mobileMenu, walletRechargeModal]);

  if(props?.showLocationSelector) {
    return <Navigate to='/location-selection'/>;
  }

  const confirm = async()=>{
    const res = await BreathAPIs.updateProfile({isAutoPayEnabled: false})
    console.log('res',res)
    if(res.status === 200){
      store.dispatch(loadUser())
    }
    
  }

      // useEffect( ()=>{
      //     getUserCurrentBookings()
      // },[])
  
      // const updateWallet = (amount)=>{
      //     dispatch(addAmount(amount))
      // }
  
      const getUserCurrentBookings = async ()=>{
        setIsLoading(true)
          const res = await BreathAPIs.getUpcomingBookings()
          console.log(res)
          setUserNRBookings([])
          console.log("123",res.data.length)
          res.data.map((b)=>{
              if(b.user._id === props.userID ){ //&& b.nonReservable
                  // console.log(b)
                  setUserNRBookings([b])
              }

          })
          setIsLoading(false)
      }


  return (
    <div className={'nav-header bottom-line'}>
      <div className='container nav'>
        <NavLink to="/" state={{ onBreatheIconClick: true }}  >
          <Image className={styles['logo-larger']} src={BreatheEV_Logo} alt="BreatheEV Logo" />
          <Image className={styles['logo-mobile']} src={BreatheEV_Mobile_Logo} alt="BreatheEV Logo" />
        </NavLink>
        {/* Start Larger screen menu */}
        <ul className={`navbar-nav ${styles['nav-larger']}`}>
        
          <li className="nav-item">
            <CustomPWAButton view='pc' />
          </li>
          {!props.isGuest && (
            <li className="nav-item">
              <span onClick={() => { setWalletModal(!walletModal); setFutureEstimate();  getUserCurrentBookings()}}><BiSolidWallet /> $ {props.balance?.toFixed(2)}</span>
            </li>
          )}
          <li className="nav-item">
            <NavLink className="nav-link" to="/" >
              Charge
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/bookingHist">
              View Bookings
            </NavLink>
          </li>

          <li className={userMenu ? "nav-item dropdown active" : "nav-item dropdown"} ref={userMenuRef}>
            <div className='dropdown-btn' onClick={() => { setUserMenu(!userMenu); }}><BiSolidUser /></div>
            <div className='dropdown-menu-holder' onClick={() => { setUserMenu(false); }}>
              <div className='menu-tip' />
              <div className='menu-profile' >
                <div className='menu-profile-icon'><BiSolidUser /></div>
                <div className='menu-profile-name'>{props.isGuest ? (props.email || props.phone) : props.name}</div>
              </div>
              <ul>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/support">
                    Issue Tracker
                  </NavLink>
                </li> */}
                {!props.isGuest && (
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/profile">
                      My Profile
                    </NavLink>
                  </li>
                )}
                <li className="nav-item">
                  <NavLink onClick={props.logout} className="nav-link" to="/login">
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        {/* End Larger screen menu */}

        {/* Start Mobile screen menu */}
        <ul className={`navbar-nav ${styles['nav-mobile']}`}>
          <li className="nav-item">
            <CustomPWAButton view='mobile' />
          </li>
          {!props.isGuest && (
            <li className="nav-item">
              <span onClick={() => { setWalletModal(!walletModal);setFutureEstimate(); getUserCurrentBookings()}}><BiSolidWallet /> $ {props.balance?.toFixed(2)}</span>
            </li>
          )}

          <li className={mobileMenu ? "nav-item dropdown active" : "nav-item dropdown"} ref={mobileMenuRef}>
            <div className='dropdown-btn' onClick={() => { setMobileMenu(!mobileMenu); }}>
              {<BiMenuAltRight className={mobileMenu ? `${styles['icon-rotate']} ${styles['deg-180']}` : `${styles['icon-rotate']}`} />}
            </div>
            <div className='dropdown-menu-holder' onClick={() => { setMobileMenu(false); }}>
              <div className='menu-tip' />
              <div className='menu-profile' >
                <div className='menu-profile-icon'><BiSolidUser /></div>
                <div className='menu-profile-name'>{props.isGuest ? (props.email || props.phone) : props.name}</div>
              </div>
              <ul>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/" >
                    Charge
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/bookingHist">
                    View Bookings
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/support">
                    Issue Tracker
                  </NavLink>
                </li> */}
                {!props.isGuest && (
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/profile">
                      My Profile
                    </NavLink>
                  </li>
                )}
                <li className="nav-item">
                  <NavLink onClick={props.logout} className="nav-link" to="/login">
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        {/* End Mobile screen menu */}


      </div>

      <Modal open={walletModal} onCancel={() => { setWalletModal(!walletModal) }}
        okText="Add Amount" onOk={() => { setWalletModal(!walletModal); setWalletRechargeModal(true);}} 
        footer={[<button className='btn-balance-modal' key={'btn1'} onClick={() => { setHistoryModal(!historyModal) }}>History</button>,
        <button className='btn-balance-modal' key={'btn2'} onClick={() => { setWalletModal(!walletModal); setWalletRechargeModal(true) }}>{props.autopayProp ? "Update Payment" : "Add Amount"}</button>,
        ]
        }>
          {/* {console.log(userNRBookings.length)} */}
          {
           props.autopayProp && !isloading && //(userNRBookings.length === 0) &&
          <ConfigProvider theme={{
            token: {
              colorPrimary: '#18365E',
              colorBgContainer: '#ffffff',
              boxShadow: 'none'
            },
          }}>
            <Popconfirm
              title="Confirm"
              description="Do you want to disable auto wallet reload?"
              placement='bottom'
              onConfirm={confirm}
              cancelText='No'
              okText='Yes'
              disabled={(userNRBookings.length !== 0)}
            ><span className={`${styles.disableSpan} ${((userNRBookings.length !== 0)) ? styles.disable : ''}`} pill >
                <span >Disable Auto Wallet Reload
                </span>
              </span>
            </Popconfirm>
          </ConfigProvider>
        }
        <div className='balance-modal-view'>
          <div className='balance-block'>Balance<span>${props.balance?.toFixed(2)}</span></div>
          <div className='balance-block'>Locked Amount<span>${props.futureEstimate?.toFixed(2)}</span></div>
        </div>
        
      </Modal>
      {walletRechargeModal && <Modal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null} style={{overflow:'hidden'}}>
        <StripePayment setWalletRechargeModal={setWalletRechargeModal} amountToAdd={10} autoPayProp={props.autopayProp}/>
      
      </Modal>}
      {historyModal&& <Modal open={historyModal} onCancel={() => { setHistoryModal(!historyModal); setPaymentHistoryPageNumber(1) }} footer={<Button onClick={() => { setHistoryModal(!historyModal); setPaymentHistoryPageNumber(1) }}>Cancel</Button>}>
        <PaymentHistory paymentHistoryPageNumber={paymentHistoryPageNumber} setPaymentHistoryPageNumber={setPaymentHistoryPageNumber}></PaymentHistory>
      </Modal>}

    </div>
  );
};

Header.propTypes = {
  logout: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool,
  balance: PropTypes.number,
  name: PropTypes.string,
  email: PropTypes.string,
  isGuest: PropTypes.bool,
  phone: PropTypes.string,
  jwt: PropTypes.string,
  futureEstimate: PropTypes.number,
  userID: PropTypes.string,
  showLocationSelector: PropTypes.bool,
  autopayProp: PropTypes.bool
}
const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  name: state.auth && state.auth.user ? state.auth.user.firstName : null,
  email: state.auth && state.auth.user ? state.auth.user.email : null,
  phone: state.auth && state.auth.user ? state.auth.user.phone : null,
  isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,
  jwt: state.auth ? state.auth.token : null,
  location: state.auth ? state.auth.user.location : null,
  futureEstimate: state.auth.futureEstimate ? state.auth.futureEstimate : 0,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  showLocationSelector: state.auth && state.auth.user ? state.auth.user.showLocationSelector : false,
  autopayProp: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
});

export default connect(mapStateToProps, { logout })(Header);